module.exports = __webpack_public_path__ + "img/marker_selected_focused.0be85489.svg";